import { Button, Form, Input, message, Modal } from "antd";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { lib } from "../index";
import { SafetyCertificateOutlined } from "@ant-design/icons";
import { SendSmsCode } from "./send-sms-code";
import { appStore } from "../app/store";
import "./export-btn.less";

/**
 *
 * @param {boolean} exportVerify  是否需要短信验证
 * @param {boolean} exportDisabled 导出是否禁用态 true 禁用
 * @param {string} exportUrl
 * @param {Object} exportUrlParam
 * @return {JSX.Element}
 * @constructor
 */
export function ExportBtn({ exportVerify = false, exportDisabled = false, exportUrl, exportUrlParam }) {
    const [visible, setVisible] = useState(false);
    const [mobile, setMobile] = useState("");
    const [form] = Form.useForm();
    const ref = useRef();
    useEffect(() => {
        if (visible) {
            lib.request({
                url: "/ucenter-account/current/userInfo",
                success: data => {
                    setMobile(data.mobile);
                    appStore.userInfo = data;
                    localStorage["userInfo"] = JSON.stringify(data);
                },
            });
        } else {
            form.resetFields();
        }
    }, [visible]);

    const hideMobile = useMemo(() => {
        return mobile.replace(/(\d{0,3})\d{0,4}(\d{0,4})/, "$1****$2");
    }, [mobile]);

    const doExport = () => {
        lib.request({
            url: exportUrl,
            needMask: true,
            data: exportUrlParam,
            success: json => {
                lib.openPage("/excel/download-center?page_title=下载中心");
            },
        });
    };
    return (
        <>
            <Button
                className="btn"
                disabled={exportDisabled}
                onClick={() => {
                    if (exportVerify) {
                        setVisible(true);
                    } else {
                        doExport();
                    }
                }}>
                导出 &#xe638;
            </Button>
            <Modal
                title="导出验证"
                visible={visible}
                onCancel={() => setVisible(false)}
                onOk={() => {
                    form.submit();
                }}>
                <div>
                    <span>验证码将发送至用户的手机号 {hideMobile}，请填写验证码</span>
                    <Form
                        form={form}
                        onFinish={data => {
                            ref.current.checkSmsCode({
                                code: data.code,
                                onSuccess: () => {
                                    setVisible(false);
                                    doExport();
                                },
                            });
                        }}>
                        <div className="send-sms-code-form-item">
                            <Form.Item
                                name="code"
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入验证码",
                                    },
                                    {
                                        pattern: /^\d{0,6}$/,
                                        message: "验证码格式错误",
                                    },
                                ]}>
                                <Input
                                    size="large"
                                    placeholder="验证码"
                                    prefix={<SafetyCertificateOutlined style={{ color: "#999" }} />}
                                />
                            </Form.Item>
                            <SendSmsCode mobile={mobile} type={"CHECK_EXPORT"} ref={ref} />
                        </div>
                    </Form>
                </div>
            </Modal>
        </>
    );
}
